/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDesktopMarkAsReadModel,
  IDesktopMarkAsReadRequest,
  IMappers,
  IDesktopMarkAsReadResponse,
  IDesktopMarkAsReadResponseError,
  TDesktopMarkAsReadResponse,
} from './types';

const defaultConfig: TDesktopMarkAsReadModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/mark-as-read/',
  hostType: 'api',
} as TDesktopMarkAsReadModel;

function createDesktopMarkAsReadModel(parameters: IDesktopMarkAsReadRequest): TDesktopMarkAsReadModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopMarkAsReadOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IDesktopMarkAsReadRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchDesktopMarkAsRead<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDesktopMarkAsReadOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TDesktopMarkAsReadResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDesktopMarkAsReadModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IDesktopMarkAsReadResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IDesktopMarkAsReadResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TDesktopMarkAsReadResponse;
}

export { defaultConfig, createDesktopMarkAsReadModel, fetchDesktopMarkAsRead };
